import { render } from "./PaymentSuccessPage.vue?vue&type=template&id=58f0f9ba&scoped=true"
import script from "./PaymentSuccessPage.vue?vue&type=script&lang=js"
export * from "./PaymentSuccessPage.vue?vue&type=script&lang=js"

import "./PaymentSuccessPage.vue?vue&type=style&index=0&id=58f0f9ba&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58f0f9ba"]])

export default __exports__